// components/layout/ProtectedRoute.tsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Spinner } from '../ui/Spinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'super_admin' | 'leasing_agent';
  buildingId?: string;
}

export function ProtectedRoute({
  children,
  requiredRole,
  buildingId,
}: ProtectedRouteProps) {
  const { user, loading, isSuper, canAccessBuilding } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Spinner fullScreen />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole === 'super_admin' && !isSuper) {
    return <Navigate to="/admin" replace />;
  }

  if (buildingId && !canAccessBuilding(buildingId)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
